// 数据字典对应的值
// 供应商类型 =======> 物流供应商
export const LOGISTICS_SUPPLIER = '70';

// 供应商类型 =======> 其他供应商
export const OTHER_SUPPLIER = '90';

// 供应商类型 =======> 内部供应商
export const INNER_SUPPLIER = '100';

// 供应商类型 =======> 员工供应商
export const STAFF_SUPPLIER = '120';

// 供应商类型 =======> 海运费供应商
export const OCEANFREIGHT_SUPPLIER = '130';

// 业务类型 =====> 仓储
export const STORAGE_NUM = '1';

// 业务类型 =====> 装卸
export const LOAD_AND_UNLOAD_NUM = '2';

// 业务类型 =====> 运输
export const TRANSPORTATION_NUM = '3';

// 业务类型 =====> 配送
export const DISPATCH_NUM = '4';

// 业务类型 =====> 快递
export const EXPRESS_NUM = '5';

// 业务类型 =====> 宅配
export const HOME_DELIVERY_NUM = '10';

// 业务类型 =====> 电商
export const DS_NUM = '21';

// 业务类型 =====> 报关
export const BG_NUM = '22';

// 运输方式 =====> 海运
export const SEA_TRANSPORTATION_NUM = '10';

// 运输方式 =====> 其他
export const TPT_OTHER_NUM = '80';

// 运输方式 =====> 报关
export const TPT_BG_NUM = '90';

// 运输方式 =====> 电商
export const TPT_DS_NUM = '100';

// 合作方式 ======> 仓库租赁
export const LEASING_STORAGE_NUM = '2';

// 合作方式 ======> 仓管及仓租
export const LEASING_STORAGE_LEASE_NUM = '3';

// 主体性质 ======> 个体
export const PERSON = '2';
export const PERSON_TEXT = '国内（个人）';

// 主体性质 =======> 公司
export const COMPANY = '1';
export const COMPANY_TEXT = '国内（公司、个体户）';

// 主体性质 =======> 国外
export const ABROAD = '3';
export const ABROAD_TEXT = '国外';

// 主体性质 =======> 非营利机构
export const ORGANIZATION = '4';
export const ORGANIZATION_TEXT = '国内（非营利机构）';

// 主体性质 =======> 港澳台
export const HKMCTW = '5';
export const HKMCTW_TEXT = '港澳台';
